import React from 'react';

interface TableWrapperProps {
  children: React.ReactNode;
  // When the table is nested inside an existing panel that already provides
  // a border + rounded corners, pass inset to skip the wrapper chrome.
  inset?: boolean;
}

export function TableWrapper({ children, inset = false }: TableWrapperProps) {
  return (
    <div className={`overflow-x-auto ${inset ? '' : 'rounded-lg border border-gray-800'}`}>
      <table className="w-full text-sm">{children}</table>
    </div>
  );
}

export function Thead({ children }: { children: React.ReactNode }) {
  return (
    <thead className="sticky top-0 bg-gray-900 z-10">
      <tr className="text-gray-500 text-xs uppercase tracking-wider border-b border-gray-800">
        {children}
      </tr>
    </thead>
  );
}

interface ThProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  title?: string;
}

export function Th({ children, className = '', onClick, title }: ThProps) {
  const clickable = !!onClick;
  return (
    <th
      onClick={onClick}
      title={title}
      className={`text-left px-3 py-2.5 font-medium ${clickable ? 'cursor-pointer select-none hover:text-white' : ''} ${className}`}
    >
      {children}
    </th>
  );
}

export function Tbody({ children }: { children: React.ReactNode }) {
  return <tbody className="divide-y divide-gray-800">{children}</tbody>;
}

interface TrProps {
  children: React.ReactNode;
  className?: string;
}

export function Tr({ children, className = '' }: TrProps) {
  return (
    <tr className={`hover:bg-gray-800/50 transition-colors ${className}`}>
      {children}
    </tr>
  );
}

interface TdProps {
  children: React.ReactNode;
  className?: string;
  colSpan?: number;
  title?: string;
}

export function Td({ children, className = '', colSpan, title }: TdProps) {
  return (
    <td colSpan={colSpan} title={title} className={`px-3 py-2.5 ${className}`}>
      {children}
    </td>
  );
}
